/**
 * Arena Stats - Institutions Service
 * Serviço para gerenciamento de instituições e vínculos
 */

import { AZURE } from './api';

// ===== INSTITUTIONS =====

export const getAllInstitutions = async (params = {}) => {
  const { data } = await AZURE.get('/institutions', { params });
  return data.data;
};

export const searchInstitutions = async (query, limit = 10) => {
  const { data } = await AZURE.get('/institutions/search', {
    params: { q: query, limit }
  });
  return data.data;
};

export const getInstitutionById = async (institutionId) => {
  const { data } = await AZURE.get(`/institutions/${institutionId}`);
  return data.data;
};

export const createInstitution = async (institutionData) => {
  const { data } = await AZURE.post('/institutions', institutionData);
  return data.data;
};

export const updateInstitution = async (institutionId, updates) => {
  const { data } = await AZURE.put(`/institutions/${institutionId}`, updates);
  return data;
};

export const deleteInstitution = async (institutionId) => {
  const { data } = await AZURE.delete(`/institutions/${institutionId}`);
  return data;
};

// ===== USER <-> INSTITUTION LINKS =====

export const getUserInstitutions = async (userId) => {
  const { data } = await AZURE.get(`/users/${userId}/institutions`);
  return data.data;
};

export const linkUserToInstitution = async (userId, linkData) => {
  const { data } = await AZURE.post(`/users/${userId}/institutions`, linkData);
  return data.data;
};

export const unlinkUserFromInstitution = async (userId, institutionId) => {
  const { data } = await AZURE.delete(`/users/${userId}/institutions/${institutionId}`);
  return data;
};

// ===== USER PROFILE (ARENA MODE) =====

export const getUserProfileComplete = async (userId) => {
  const { data } = await AZURE.get(`/users/${userId}/profile/complete`);
  return data.data;
};

// ===== BADGES =====

export const getUserBadges = async (userId) => {
  const { data } = await AZURE.get(`/users/${userId}/badges`);
  return data.data;
};

export const awardBadgeToUser = async (userId, badgeId, displayOrder = 0) => {
  const { data } = await AZURE.post(`/users/${userId}/badges`, {
    badge_id: badgeId,
    display_order: displayOrder
  });
  return data;
};

// ===== RELEASES =====

export const getUserReleases = async (userId, limit = 10) => {
  const { data } = await AZURE.get(`/users/${userId}/releases`, {
    params: { limit }
  });
  return data.data;
};

export const createRelease = async (userId, releaseData) => {
  const { data } = await AZURE.post(`/users/${userId}/releases`, releaseData);
  return data.data;
};

// ===== HELPERS =====

export const INSTITUTION_TYPES = [
  { value: 'startup', label: 'Startup' },
  { value: 'company', label: 'Empresa' },
  { value: 'club', label: 'Clube Esportivo' },
  { value: 'federation', label: 'Federação' },
  { value: 'ngo', label: 'ONG' },
  { value: 'accelerator', label: 'Aceleradora' },
  { value: 'university', label: 'Universidade' },
  { value: 'other', label: 'Outro' }
];

export const INSTITUTION_SIZES = [
  { value: '1-10', label: '1-10 pessoas' },
  { value: '11-50', label: '11-50 pessoas' },
  { value: '51-200', label: '51-200 pessoas' },
  { value: '201-500', label: '201-500 pessoas' },
  { value: '500+', label: '500+ pessoas' }
];

export const RELEASE_TYPES = [
  { value: 'release', label: 'Release', color: '#111111', icon: '🚀' },
  { value: 'dataset', label: 'Dataset', color: '#0891b2', icon: '📊' },
  { value: 'feature', label: 'New Feature', color: '#7c3aed', icon: '✨' },
  { value: 'fix', label: 'Fix', color: '#dc2626', icon: '🔧' },
  { value: 'partnership', label: 'Partnership', color: '#ea580c', icon: '🤝' },
  { value: 'research', label: 'Research Note', color: '#0284c7', icon: '📝' }
];
